module.exports = __webpack_public_path__ + "media/images/bt-pagar-conta-clicado-920448347ac5b405b3a5b6b13d2e2b0a.svg";